import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { createInvitation as createInvitationService, InvitationModel } from '../../../services/user/UserService';

interface Values {
  isLoading: boolean;
  createInvitation: (organizationId: string, email: string) => void;
}

const useCreateInvitation = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createInvitation = async (organizationId: string, email: string) => {
    try {
      setIsLoading(true);
      const newInvitation = {} as InvitationModel;
      newInvitation.email = email;

      await createInvitationService(organizationId, newInvitation);
      setIsLoading(false);
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }
  };

  return { createInvitation, isLoading };
};

export default useCreateInvitation;
